import React from "react";

const CLASSIFICATIONS = [
  { value: "BUSINESS_CREDIT", label: "אשראי עסקי", icon: "🏢", desc: "הלוואות לעסקים" },
  { value: "INCOME_REAL_ESTATE", label: 'נדל"ן מניב', icon: "🏬", desc: "נכס מניב הכנסה" },
  { value: "CONSTRUCTION_FINANCE", label: "ליווי בנייה", icon: "🏗️", desc: "מימון פרויקטי בנייה" },
  { value: "LAND_LOAN", label: "הלוואת קרקע", icon: "🌍", desc: "רכישת קרקע" },
  { value: "LOAN", label: "הלוואה", icon: "💰", desc: "הלוואה כללית" },
  { value: "CREDIT_FACILITY", label: "מסגרת אשראי", icon: "💳", desc: "אשראי מתגלגל" },
  { value: "OTHER", label: "אחר", icon: "📋", desc: "סיווג אחר" },
];

/**
 * Card-grid classification picker — replaces the classification <select>.
 * Props:
 *   value    string  — current classification value
 *   onChange fn      — receives synthetic event { target: { name: "classification", value } }
 *   error    string  — optional error message to display
 */
export default function ClassificationSelector({ value, onChange, error }) {
  const handleClick = (optValue) => {
    onChange({ target: { name: "classification", value: optValue } });
  };

  return (
    <div style={{ marginBottom: "var(--space-lg)" }}>
      <p className="classification-section-label">סיווג ההלוואה</p>
      <div className="loan-classification-grid">
        {CLASSIFICATIONS.map((c) => (
          <div
            key={c.value}
            className={`loan-classification-card${value === c.value ? " selected" : ""}`}
            onClick={() => handleClick(c.value)}
          >
            <span className="loan-classification-card-icon">{c.icon}</span>
            <span className="loan-classification-card-label">{c.label}</span>
            <span className="loan-classification-card-desc">{c.desc}</span>
          </div>
        ))}
      </div>
      {error && <div className="field-error">{error}</div>}
    </div>
  );
}
